// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".preview-title[data-v-18e28ae4] {\n  line-height: 16px;\n  font-size: 16px;\n  margin-bottom: 10px;\n}\n.preview .custom-row[data-v-18e28ae4] {\n  display: flex;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n}\n.preview .custom-row .custom-col[data-v-18e28ae4] {\n  width: 50%;\n  margin-bottom: 10px;\n  font-size: 14px;\n  color: #999;\n  display: flex;\n}\n.preview .custom-row .custom-col .custom-label[data-v-18e28ae4] {\n  min-width: 80px;\n  margin-right: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
